import { ReturnsIntakeSearchBar, ReturnsIntakeDescription } from '../../components';
import { LoaderBackdrop, NavigateLinks, Table } from '@/components';
import { ReturnsIntakeFilters } from '../../models';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useSortableData } from '@/hooks';
import {
  childrenReturnsIntakeNotReportedShippingsBreadcrumbs,
  getNotReportedShippingsColumns,
} from '../../config';
import {
  useNotReportedShippings,
  useReturnsIntakeFilter,
  useReturnsIntakePagination,
} from '../../hooks';

export const NotReportedShippingsWithReturnsIntake = () => {
  const navigate = useNavigate();

  const { filter, setFilter, initialFilter } = useReturnsIntakeFilter(true, 'BUSINESS-RETURNS-INTAKE-NOT-REPORTED-FILTERS');
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useReturnsIntakePagination();

  const { shippings, totalItems, totalPages, isLoading, formatDate } =
    useNotReportedShippings({
      filters: filter || {},
      page: currentPage,
      pageSize,
    });

  const { sortedData, handleSort, selectedSort } = useSortableData({
    data: shippings || [],
    currentPage,
  });

  const breadcrumbs = useMemo(
    () => childrenReturnsIntakeNotReportedShippingsBreadcrumbs(navigate),
    [navigate]
  );

  const columns = useMemo(
    () =>
      getNotReportedShippingsColumns({
        formatDate,
      }),
    [formatDate]
  );

  const handleSearch = (filters: ReturnsIntakeFilters) => {
    setFilter(filters);
    handlePageChange(1);
  };

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks
        actualPage='Pedidos no reportados'
        breadcrumbs={breadcrumbs}
      />

      {isLoading && <LoaderBackdrop />}

      <ReturnsIntakeDescription 
        title="Pedidos No Reportados"
        description="Listado de pedidos que no fueron devueltos por el conductor durante el proceso de rendición y no han registrado movimiento desde entonces."
        color="#ff7500"
        icon="report"
        iconColor="#ef4444"
      />

      <ReturnsIntakeSearchBar
        search={handleSearch}
        initialFilter={initialFilter}
        filter={filter}
        hideStatus={true}
        dateLabel='Fecha'
        showShippingNumber={true}
      />

      <div className='bg-white rounded-sm shadow-xl p-5 flex flex-col gap-5'>
        {shippings?.length > 0 || isLoading ? (
          <Table
            columns={columns}
            data={sortedData}
            handleSort={handleSort}
            selectedSort={selectedSort}
            isLoading={isLoading}
            getRowKey={(row) => row.shippingNumber}
            pagination={{
              totalItems,
              totalPages,
              currentPage,
              rowsPerPage: pageSize,
              onPageChange: handlePageChange,
              onRowsPerPageChange: handlePageSizeChange,
            }}
          />
        ) : (
          <span className='text-gray-500 text-sm italic text-center py-10'>
            No se han encontrado pedidos no reportados con los criterios
            actuales.
          </span>
        )}
      </div>
    </section>
  );
};
